import React, { FC, useState } from 'react';
import { FormInput } from '../merchants/FormInput';
import {
	FORGOT_PASSWORD_FORM_FIELDS,
	FORGOT_PASSWORD_FORM_FIELDS_NAMES, forgotPasswordInitialValues, getForgotPasswordDetailSchema,
} from '../../constants/forgot-password/forgot-password-form';
import { InputType } from '../form/form-input-constants';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { useFormik } from 'formik';
import { forgotPassword } from '../../store/identyti/actions/forgot-password';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';

export const ForgotPasswordEmailForm: FC = () => {
	const { t } = useTranslation();
	// const { pathname } = useLocation();
	const navigate = useNavigate();

	const [loading, setLoading] = useState<boolean>(false);
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	const formik = useFormik({
		initialValues: forgotPasswordInitialValues,
		validationSchema: getForgotPasswordDetailSchema(t),
		onSubmit: async () => {
			if (!formik.isValid) return;

			setLoading(true);

			try {

				const email = formik.values.email;

					await forgotPassword(email, formik);
					successModal();
				// setTimeout(() => {
				//
				// 	// navigate(`${pathname}?step=2&email=${formik.values.email}`);
				// 	// setLoading(false);
				// }, 5000);

				// setLoading(false);
			} catch (e) {
				console.log('forgotPassword error', e.response);
			}
			finally {
				setLoading(false);
			}
		}
	});

	const successModal = (): void => {
		setModalState({
			isOpen: true,
			modalTitle: 'Forgot password',
			content: (
				<div className="px-8 pb-8">
					<div className="text-center fs-2 mb-5">
						{t('FORGOT_PASSWORD.MODAL_TITLE')}
					</div>
					<div className="text-center">
						{t('FORGOT_PASSWORD.MODAL_TEXT_1')}
						<span className="fw-bolder ms-1">{formik.values.email}</span>.
					</div>
					<div>
						{t('FORGOT_PASSWORD.MODAL_TEXT_2')}
					</div>

					<ButtonComponent
						buttonType={BUTTON_TYPE.DEFAULT_BLACK}
						buttonName={t('FORGOT_PASSWORD.MODAL_BTN_NAME')}
						additionalClass="no-letter-spacing mt-10 mx-auto d-block"
						onButtonClick={(): void => navigate('/auth/login')}
					/>
				</div>
			),
			minHeight: 100,
			onClose: (): void => navigate('/auth/login')
		});
	};

	return (
		<>
			{/* Page Title */}
			<h1 className="forgot-password-title mb-3">
				{t('FORGOT_PASSWORD.FORGOT_PASS')}
			</h1>

			{/* Subtext */}
			<div className="forgot-password-subtext text-muted mb-10">
				{t('FORGOT_PASSWORD.SUB_TITLE_RESET')}
			</div>

			{/* Form */}
			<form
				className="forgot-password-form w-100"
				onSubmit={formik.handleSubmit}
				noValidate
			>
				<FormInput
					formik={formik}
					fieldName={FORGOT_PASSWORD_FORM_FIELDS.EMAIL}
					placeholder={t(FORGOT_PASSWORD_FORM_FIELDS_NAMES.EMAIL)}
					label={t(FORGOT_PASSWORD_FORM_FIELDS_NAMES.EMAIL)}
					inputType={InputType.Text}
					additionalClasses="col-12 col-sm-12 col-md-12 mb-5"
					required
				/>

				<ButtonComponent
					buttonType={BUTTON_TYPE.DEFAULT_BLACK}
					buttonName={t('FORGOT_PASSWORD.BTN_NAME')}
					type="submit"
					loading={loading}
					isDisabled={!formik.values.email || loading}
					additionalClass="w-100"
				/>


			</form>

			<ModalWindow
				{...modalState}
			/>
		</>
	);
};
